var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldTelescope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7.109c.57-.38.72-1.16.34-1.72l-1.82-2.71c-.38-.57-1.16-.72-1.72-.34l-5.66 3.79 3.2 4.77 5.66-3.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.76 11.602-2.67 1.79-.35.23-.16-.24-2.24-3.34-.16-.24 4.78-3.2 2.56 3.82-1.76 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.59 13.38-2.24-3.34-3.95 2.64c-.46.31-.58.93-.27 1.39l1.13 1.68c.3.46.92.58 1.38.27l3.95-2.64zM16.25 21.882c-.29 0-.56-.17-.69-.45l-3.73-8.24-3.78 8.25a.77.77 0 0 1-.69.44.87.87 0 0 1-.31-.07.766.766 0 0 1-.37-1l3.41-7.42 2.67-1.79 4.17 9.22c.17.37 0 .82-.37.99a.87.87 0 0 1-.31.07z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldTelescope);
export default __webpack_public_path__ + "static/media/vuesax-bold-telescope.6bef48b0fa28e0d93bc6031a73ce578b.svg";
export { ForwardRef as ReactComponent };